import { PRODUCTION_ENVIRONMENT } from '@os-components';
import { authProd } from './environment-variables';

export const environment = {
    ...PRODUCTION_ENVIRONMENT,
    baseURLs: {
        ...PRODUCTION_ENVIRONMENT.baseURLs,
        href: '/os/ecs/',
        api: {
            ...PRODUCTION_ENVIRONMENT.baseURLs.api,
            domain: '',
            path: '/os/api/ecs',
        },
    },
    auth: authProd,
    tokens: {
        accessory:
            'A39ACB2EAEA34C86A64B410B86A39B433E52823AE08B405CB5705CE833D4C27E225F2E70DB1C4FDAB4BC8B64131C1887',
    },
    apiGateway: {
        ...PRODUCTION_ENVIRONMENT.apiGateway,
        dmz: {
            ...PRODUCTION_ENVIRONMENT.apiGateway.dmz,
            apiKey: '390516ef-b01b-4271-932a-b2f3f11eb4aa',
            paths: {
                drSerialnumberOcr: '/dr-serialnumber-ocr/1.1.0/serialnumber',
            },
        },
    },
};
